var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"accent"},on:{"click":function($event){return _vm.signIn()}}},[_c('v-icon',[_vm._v("mdi-microsoft-office")]),_vm._v(" Anmelden ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }